"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var Gesture_1 = __importDefault(require("@material-ui/icons/Gesture"));
var useStatusClass_1 = __importDefault(require("./useStatusClass"));
var DocumentPageSignatureInputDialog_1 = __importDefault(require("./DocumentPageSignatureInputDialog"));
var types_1 = require("../../types");
var useStyles = styles_1.makeStyles({
    root: {
        height: '100%',
        width: '100%',
        border: 0,
        padding: 0,
    },
    icon: {
        fontSize: '14px',
        float: 'right',
        marginRight: 5,
    },
    readout: {
        color: 'black',
        float: 'left',
        marginLeft: '5px',
    },
    impression: {
        color: '#333',
        fontFamily: 'Caflischscriptpro',
    },
    '@font-face': {
        fontFamily: 'Caflischscriptpro',
        src: [
            "url('https://payrollplus-assets.castandcrew.com/caflischscriptpro-regular.otf')",
        ],
    },
});
var DocumentPageSignatureInput = function (_a) {
    var actor = _a.actor, input = _a.input, isAutosignActive = _a.isAutosignActive, onChange = _a.onChange, onFocus = _a.onFocus;
    var id = input.id, isInitials = input.isInitials, isValidated = input.isValidated, status = input.status, value = input.value;
    var name = actor.name, initials = actor.initials;
    var expectedImpression = isInitials ? initials : name;
    var classes = useStyles();
    var statusClass = useStatusClass_1.default(status);
    var _b = react_1.useState(false), isDialogOpen = _b[0], setIsDialogOpen = _b[1];
    var handleClick = function () {
        if (isValidated && isAutosignActive) {
            onChange(expectedImpression);
            return;
        }
        setIsDialogOpen(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: statusClass + " " + classes.root, "data-tid": "DocumentPageSignatureInput-button-" + id, disabled: status === types_1.PageInputStatus.Disabled, onClick: handleClick, onFocus: function () { return onFocus(); } },
            react_1.default.createElement("span", { className: classes.readout + " " + (value !== null && value !== void 0 ? value : classes.impression) }, value ? value : "- click to " + (isInitials ? 'initial' : 'sign') + " -"),
            react_1.default.createElement(Gesture_1.default, { className: classes.icon })),
        react_1.default.createElement(DocumentPageSignatureInputDialog_1.default, { isInitials: isInitials, onClose: function () { return setIsDialogOpen(false); }, onSubmit: onChange, open: isDialogOpen, requiredImpression: isValidated ? expectedImpression : '' })));
};
exports.default = DocumentPageSignatureInput;
//# sourceMappingURL=DocumentPageSignatureInput.js.map